import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * The Data Gateway's `get<Schema>s` queries take native `where` / `order` / `paging` arguments
 * instead of a single JSON-string `input: DynamicQueryInput` — see graphql-query-builder.ts for
 * why these are inlined as literals rather than passed as typed variables. Paged lists sort on the
 * server (`buildOrderLiteral`), so each page is a slice of the sorted whole.
 */
export const buildGetLunchMenusQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    LunchMenus: getLunchMenus(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        Name
        WeekDay
        MenuItems
        IsActive
      }
    }
  }
`;

/**
 * Grouped by unit (department), in request order within a unit by default, like the old food
 * request list (`FoodRequestComponent.sortByUnit` over the requests in stored order).
 */
export const DEFAULT_LUNCH_REQUESTS_ORDER: OrderBy[] = [
  { field: 'DepartmentName', direction: 'ASC' },
  { field: 'CreatedDate', direction: 'ASC' },
];

export const buildGetLunchRequestsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_LUNCH_REQUESTS_ORDER
) => `
  query {
    LunchRequests: getLunchRequests(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        UserId
        DisplayName
        DepartmentName
        DepartmentKey
        MenuId
        MenuName
        MenuItems
        RequestedForDate
        CreatedDate
      }
    }
  }
`;
